import { render, staticRenderFns } from "./MiniSpinner.vue?vue&type=template&id=0d79fe40&scoped=true&"
import script from "./MiniSpinner.vue?vue&type=script&lang=js&"
export * from "./MiniSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d79fe40",
  null
  
)

export default component.exports